import React, { useState, useEffect } from 'react';
import { Badge, Dropdown, Menu, Input, Select } from 'antd';
import { Panel, PanelType, Persona, PersonaSize } from '@fluentui/react';
import { Color, ConstCss } from '../../const/Const';
import { ReactComponent as MenuLogo } from '../../svg/menu.svg';
import { ReactComponent as Divider } from '../../svg/verticalDivider.svg';
import { ReactComponent as DropdownIcon } from '../../svg/dropdown.svg';
import { ReactComponent as NotificationIcon } from '../../svg/notification.svg';
import { ReactComponent as QuestionIcon } from '../../svg/question.svg'
import { ReactComponent as MenuBlackIcon } from '../../svg/menuBlackIcon.svg';
import { ReactComponent as MenuBack } from '../../svg/menuBack.svg';
import { ReactComponent as MenuUserIcon } from '../../svg/menuUserIcon.svg';
import { ReactComponent as SearchIcon } from '../../svg/searchBlack.svg';

const { Option } = Select;
const Header = (props) => {

    const [showMenu, setShowMenu] = useState(false);
    const [menuKey, setMenuKey] = useState();
    const [menuText, setMenuText] = useState();
    const [backPath, setBackPath] = useState();
    const [selectedSearchMenu, setSelectedSearchMenu] = useState('ALL');
    const menuData = props.menuData ? props.menuData : {};
    const userMenu = props.userMenu ? props.userMenu : [];
    const [notificationCount, setNotificationCount] = useState(0);

    useEffect(() => {
        if (props?.notificationCount) {
            setNotificationCount(props?.notificationCount);
        }

        let tMenuKey = '';
        let tMenuText = '';
        let tMenuKeyParent = '';
        let tBackPath = '';
        if (props.location?.pathname) {
            let tPath = props.location?.pathname?.split('/');
            if (tPath.length >= 1) {
                tMenuKey = tPath[1];
                if (tPath.length > 3) {
                    tPath.pop();
                    tBackPath = tPath.join('/');
                }
            }
        }

        if (tMenuKey) {

            Object.keys(menuData).map(key => {
                menuData[key]?.map(r => {
                    if (r.path == tMenuKey) {
                        tMenuKeyParent = key;
                    }
                })
            });

            let tMenuData = menuData[tMenuKeyParent];
            let tIndex = tMenuData?.map(r => r.path).indexOf(tMenuKey);
            if (tIndex >= 0) {
                tMenuText = tMenuData[tIndex].text;
            }

        }

        setMenuKey(tMenuKeyParent);
        setMenuText(tMenuText);
        setBackPath(tBackPath);
    }, [props.location?.pathname, props?.notificationCount]);

    const onChangeMenu = (value) => {
        if (props.navigate) {
            props.navigate('/' + value.key);
        }
    }

    let menuComp = (
        <Menu onClick={onChangeMenu}>

            {menuKey && menuData[menuKey]
                ? (
                    menuData[menuKey].map(r => {
                        return (
                            <Menu.Item key={r.path}>
                                {r.text}
                            </Menu.Item>
                        );
                    })
                ) : null
            }
        </Menu>
    );

    const logOut = () => {
        if (props.logOut) {
            props.logOut();
        }
    }

    let userComp = (
        <Menu onClick={onChangeMenu}>
            {userMenu &&
                (userMenu?.map(r => {
                    return (
                        <Menu.Item key={r.path}>
                            {r.text}
                        </Menu.Item>
                    )
                }))
            }
            <Menu.Item key="logout" onClick={logOut}>
                {props?.lang == "en" ? "Logout " : "Гарах"}
            </Menu.Item>
        </Menu>
    );

    const onPressMenu = () => {
        setShowMenu(r => !r);
    }

    const onPressQuestion = () => {
        if (props.questionDocUrl) {
            window.open(`${props.questionDocUrl}`, '_blank');
        }
    }

    const onPressBack = () => {
        if (props.navigate) {
            if (props.location?.state?.backurl) {
                props.navigate(backPath);
            } else {
                props.navigate(-1);
            }
        }
    }

    const onPressNotification = () => {
        if (props.onPressNotification) {
            props.onPressNotification();
        }
    }

    const onPressCompanyName = () => {
        if (props.onPressCompanyName) {
            props.onPressCompanyName();
        }
    }

    const onSearchMenuChange = (value) => {
        setSelectedSearchMenu(value);
    }

    const onSearch = (e) => {
        if (props.onSearch) {
            props.onSearch(e.target.value, selectedSearchMenu);
        }
    }

    let vPosition = {
        position: "fixed",
        top: 0,
        right: 0,
        zIndex: 100
    }

    if (props?.disablePosition) {
        vPosition = {};
    }

    return (
        <div>
            <div style={{
                width: '100%',
                height: '48px',
                backgroundColor: props.color ? props.color : Color.primary,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                paddingLeft: '14px',
                paddingRight: '16px',
                ...vPosition

            }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>

                    {backPath ? (
                        <div onClick={onPressBack} style={{ cursor: 'pointer', marginRight: 16, ...ConstCss.flexCenter }}>
                            <MenuBack />
                        </div>
                    ) : null}

                    <div onClick={onPressMenu} style={{ cursor: 'pointer', ...ConstCss.flexCenter }}>
                        <MenuLogo />
                    </div>
                    <div onClick={onPressCompanyName} style={{ marginLeft: 22, ...ConstCss.flexCenter, fontSize: 14, fontWeight: 'bold', color: Color.white, cursor: 'pointer' }}>
                        {props?.companyname?.substring(0, 60)}{props?.companyname?.length > 60 && "..."}
                    </div>
                    <div style={{ marginLeft: 17, marginRight: 17, ...ConstCss.flexCenter }}>
                        <Divider />
                    </div>
                    <div>
                        <Dropdown overlay={menuComp} trigger={['click']}>
                            <div style={{ ...ConstCss.flexCenter, cursor: 'pointer' }}>
                                <div style={{
                                    fontWeight: '600',
                                    fontSize: '14px',
                                    color: Color.white
                                }}>{menuText}</div>
                                <div style={{ paddingLeft: 12, marginTop: -6 }}>
                                    <DropdownIcon />
                                </div>
                            </div>
                        </Dropdown>
                    </div>
                </div>
                {props?.searchEnabled &&
                    <div style={{ ...ConstCss.flexCenter, width: '60%' }}>
                        <Input.Group compact style={{ ...ConstCss.flexCenter }}>
                            <Select
                                defaultValue={'_all'}
                                style={{ width: '10%', backgroundColor: '#E7E7E7' }}
                                onChange={onSearchMenuChange}
                                backgroundColor="#E7E7E7"
                            >
                                {props?.searchmenu?.map(item => (
                                    <Option value={item.key}>
                                        {item.text}
                                    </Option>
                                ))}
                            </Select>
                            <Input
                                allowClear
                                style={{ width: '40%' }}
                                onChange={onSearch}
                            />
                        </Input.Group>
                    </div>
                }
                <div style={{ ...ConstCss.flexCenter }}>
                    <div onClick={onPressNotification} style={{ cursor: 'pointer', marginLeft: 30, ...ConstCss.flexCenter }}>
                        <Badge count={notificationCount} size="small">
                            <NotificationIcon />
                        </Badge>
                    </div>
                    <div onClick={onPressQuestion} style={{ cursor: 'pointer', marginLeft: 30, ...ConstCss.flexCenter }}>
                        <QuestionIcon />
                    </div>
                    {props?.addRightComp ? props?.addRightComp : null}
                    <div style={{ cursor: 'pointer', marginLeft: 30, ...ConstCss.flexCenter }}>
                        <Dropdown overlay={userComp} trigger={['click']}>
                            <Persona hidePersonaDetails text={props.userid ? props.userid : ""} size={PersonaSize.size32} />
                        </Dropdown>
                    </div>
                </div>
            </div>
            <Panel
                headerText={props.title}
                isOpen={showMenu}
                onDismiss={onPressMenu}
                hasCloseButton={false}
                isLightDismiss={true}
                type={PanelType.smallFixedNear}
                isFooterAtBottom={true}
                onRenderHeader={() => {
                    return (
                        <div onClick={onPressMenu} style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: 36, justifyItems: 'center', cursor: 'pointer' }}>
                            <div style={{ marginLeft: 24 }}>
                                <MenuBlackIcon />
                            </div>
                            <div style={{ fontWeight: 'bold', fontSize: 14, marginLeft: 10 }}>
                                {props.title}
                            </div>
                        </div>
                    );
                }}
                onRenderFooter={() => {
                    return (
                        <div
                            onClick={() => {
                                setShowMenu(false);
                                props.navigate('/settings');
                            }}
                            style={{ display: 'flex', cursor: 'pointer', marginBottom: 16, borderTop: '1px solid rgb(237, 235, 233)' }}>
                            <div style={{ marginLeft: 24, marginTop: 16 }}>
                                <MenuUserIcon />
                            </div>
                            <div style={{ marginLeft: 10, marginTop: 16 }}>
                                {props.settingsTitle ? props.settingsTitle : 'Тохиргоо'}
                            </div>
                        </div>
                    );
                }}
            >
                <div>
                    {props.children}
                </div>
            </Panel>
        </div>
    );
}

export default Header;